export class KafkaInferSchemaResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sampled",
            "baseName": "sampled",
            "type": "number",
            "format": ""
        },
        {
            "name": "parsedCount",
            "baseName": "parsedCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "effectiveSchema",
            "baseName": "effectiveSchema",
            "type": "Array<SchemaField>",
            "format": ""
        },
        {
            "name": "overrideParseResults",
            "baseName": "overrideParseResults",
            "type": "Array<OverrideParseResult>",
            "format": ""
        },
        {
            "name": "partitionCandidates",
            "baseName": "partitionCandidates",
            "type": "Array<PartitionCandidate>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaInferSchemaResponse.attributeTypeMap;
    }
    constructor() {
    }
}
